export default __webpack_public_path__ + "static/media/who_is_for_personal_for_me_placeholder.29a9ff20.svg";